import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex-1 text-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass($setup.bannerClass),
        ref: "elementRoot"
    }, [
        _renderSlot(_ctx.$slots, "icon", {}, () => [
            ($setup.resolvedIcon)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent($setup.resolvedIcon), {
                    key: 0,
                    class: "w-5 h-5 flex-none"
                }))
                : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "title", {}, () => [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                    _createTextVNode(_toDisplayString($props.title), 1 /* TEXT */)
                ])
            ])
        ]),
        _renderSlot(_ctx.$slots, "actions"),
        ($props.closable)
            ? (_openBlock(), _createBlock($setup["EnButton"], {
                key: 0,
                variant: "ghost",
                size: "icon",
                class: "size-6 shrink-0 p-1 mix-blend-darker hover:bg-black/8",
                onClick: $setup.onClose,
                "aria-label": "Close"
            }, {
                default: _withCtx(() => [
                    _createVNode($setup["XIcon"], { class: "w-4 h-4" })
                ]),
                _: 1 /* STABLE */
            }))
            : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */));
}
